export default __webpack_public_path__ + "locales/fi/PortalUnavailable.json?hash=6f52a26cbf32e839bbb9968870a44ac3";